export const emptyBankAccount = {
  cuentaIdExterno: "",
  iban: "Sin cuenta bancaria",
  bic: "",
}

export const setInititalAccountValues = (
  data: $TSMigrationFixMe,
  cuentasBancarias: $TSMigrationFixMe,
  setSelectedAccount: $TSMigrationFixMe,
  setFieldValue: $TSMigrationFixMe
) => {
  const cuenta = cuentasBancarias.filter(
    (cta: $TSMigrationFixMe) => cta?.id === data?.cuentaBancariaId
  )[0]
  const account = {
    iban: cuenta?.iban,
    id: cuenta?.id,
    bic: cuenta?.bic,
  }
  setSelectedAccount(account)
  setFieldValue("cuentaBancaria", {
    ...account,
    cuentaIdExterno: cuenta?.id,
    entidadBancariaId: cuenta?.id,
  })
}
